
const m = window.require("discourse/components/avatar-flair");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
